<template>
  <div class="qesthflsphb_fluid w_100">
    <div class="qesthflsphb text_center">
      <sec-title
        Text="合肥律师服务榜"
        desc-text="用真实数据还原律师服务水平，7日律师排行榜"
      />
      <div class="ranking_list between">
        <ranking-ling class="item" titleText="服务排行榜" />
        <ranking-ling class="item" titleText="好评排行榜" />
        <div class="item item1">
          <div class="ser">
            <img src="../../../assets/findlawyers/serve_star.png" alt="" />
          </div>
          <div class="avatar center">
            <img src="../../../assets/findlawyers/find_sample2.png" alt="" />
          </div>
          <div class="ti1">安徽XX律师事务所律师</div>
          <div class="num">1621</div>
          <div class="ybz">已帮助人数</div>
          <div class="tag between">
            <div>交通事故</div>
            <div>债权债务</div>
            <div>合同纠纷</div>
          </div>
          <div class="adr">地址：合肥市包河区xxxxxxxxxxxxx</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
import rankingLing from "views/home/components/rankingLing";
export default {
  components: {
    secTitle,
    rankingLing,
  },
};
</script>

<style lang="scss">
.qesthflsphb_fluid {
  .qesthflsphb {
    width: 1200px;
    padding: 50px 0;
    margin: 0 auto;
    .ranking_list {
      .item {
        width: 380px;
        padding: 28px 17px;
        background: #fff;
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
      }
      .item1 {
        position: relative;
        height: 570px;
        text-align: center;
        .ser {
          position: absolute;
          top: 32px;
          left: 0;
          img {
            width: 104px;
            height: 34px;
          }
        }
        .avatar {
          width: 114px;
          height: 125px;
          margin: 60px auto 0;
          background: url("../../../assets/findlawyers/guan.png");
          img {
            margin-top: 12px;
            width: 107px;
            height: 107px;
            border-radius: 50%;
          }
        }
        .ti1 {
          margin: 30px;
          font-size: 26px;
          line-height: 26px;
          color: #333333;
        }
        .num {
          font-size: 22px;
          color: #333333;
        }
        .ybz {
          margin-top: 13px;
          font-size: 12px;
          color: #999999;
          line-height: 12px;
        }

        .tag {
          width: 270px;
          margin: 30px auto 0;
          > div {
            font-size: 14px;
            color: #666666;
            background: #f0f6ff;
            border-radius: 14px;
            padding: 5px 14px;
          }
        }
        .adr {
          margin-top: 22px;
          font-size: 14px;
          color: #999999;
        }
      }
    }
  }
}
</style>